// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"e74b7b94","81":"fae80f68","279":"cf2c1e3b","453":"4f01fb9f","976":"b3cfc640"}[chunkId] + ".chunk.js";
};